import React from "react"
import ProductsGrid from "../components/ProductsGrid"
import ProductCard from "../components/ProductCard"
import {products} from "./dummyData"
import ProductsHeader from "../components/ProductsHeader"

const ProductsScreen = () => {
  return (
    <>
      <ProductsHeader />
      <ProductsGrid>
        {products.map(({name, image, price, term, productTagImage}, index) => (
          <ProductCard key={index} name={name} image={image} price={price} term={term} productTagImage={productTagImage ?? ""} />
        ))}
      </ProductsGrid>
    </>
  )
}

export default ProductsScreen
